import type { RedoEmailDomainRpcClient } from "@redotech/redo-email-domain-rpc/client";
import { createRedoEmailDomainRpcClient } from "@redotech/redo-email-domain-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoEmailDomainRpcClientContext: Context<
  RedoEmailDomainRpcClient | undefined
> = createContext<RedoEmailDomainRpcClient | undefined>(undefined);
RedoEmailDomainRpcClientContext.displayName = "RedoEmailDomainRpcClientContext";

export function RedoEmailDomainRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoEmailDomainRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoEmailDomainRpcClient({
      baseURL: new URL(`${baseUrl}/email-domain-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);

  return (
    <RedoEmailDomainRpcClientContext.Provider value={redoEmailDomainRpcClient}>
      {children}
    </RedoEmailDomainRpcClientContext.Provider>
  );
}
